@import 'styles/mixins';
@import 'styles/variables';

.container {
  position: relative;
  height: 100%;
  width: 100%;
}

.labelContainer {
  position: absolute;
  display: flex;
  justify-content: center;
  width: 100%;
  height: 100%;
  flex: 1;
  top: 0;
  left: 0;
  right: 0;
  align-items: center;
}

.label {
  cursor: pointer;
  display: flex;
  align-items: center;
}

.fileUploadButton {
  display: flex;
  border-radius: 4px;
  &.hovered,
  &.focusVisible {
    background: rgba($almanac-black, 0.2);
  }
}

.fileRemoveButton {
  display: flex;
  border-radius: 4px;
  &.hovered,
  &.focusVisible {
    background: rgba($almanac-black, 0.2);
  }
}

.removeButtonContainer {
  display: flex;
  align-items: center;
}

.removeIcon {
  margin: 0;
  padding: 0;
  background: none !important;
}

.cropperWrapper {
  @include z-index(greaterThanAntd);
  background-color: $white;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}

.cropperContainer {
  img {
    max-width: 100%;
    max-height: 100%;
  }
}

.cropControls {
  z-index: 10010;
  align-items: center;
  background-color: $white;
  display: flex;
  justify-content: space-between;
  left: 0;
  padding: 12px 24px;
  position: absolute;
  top: 0;
  width: 100vw;
}

.zoomContainer {
  @include inter-medium;

  display: flex;
  justify-content: flex-end;
  width: 60%;
  font-size: 14px;
  line-height: 31px;
}

.zoomLabel {
  padding-right: 10px;
}

.zoomSlider {
  width: 200px;
  margin: 10px;
}

.buttonContainer {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  width: 25%;

  > * {
    height: 40px;
    width: auto;
  }

  > * + * {
    margin-left: 10px;
  }
}

.icon {
  @include inter-medium;
  font-size: 20px;
  margin-top: -1px;
}

.hide {
  display: none;
}
